<template>
  <div class="spinal-assessment-check">
    <div
      class="
        location-select-input-group
        el-input-group el-input-group--append el-input-group--prepend
      "
    >
      <div class="el-input-group__prepend">If spine was assessed at</div>

      <el-select
        v-close-on-zoom
        :value="state.vertebrae"
        placeholder="any vertebra"
        class="vertebrae-select"
        :disabled="readonly"
        :multiple="true"
        @input="(vertebrae) => setVertebrae(vertebrae)"
      >
        <el-option
          v-for="vertebra in availableVertebrae"
          :key="vertebra.key"
          :label="vertebra.label.en"
          :value="vertebra.key"
        />
      </el-select>
    </div>
  </div>
</template>

<script>
import get from 'lodash/get';
import vertebrae from '~lib/common/config/vertebrae';

export default {
  name: 'spinal-assessment-check',
  props: [
    'readonly',
    'emitter',
    'ikey',
    'getData',
    'putData',
    'control',
  ],
  data() {
    return {
      vertebrae,
      state: {
        vertebrae: [],
      },
    };
  },
  computed: {
    availableVertebrae() {
      return vertebrae.filter(vert => {
        return this.spinalAssessments.find(caseVert => caseVert.key === vert.key);
      });
    },
    spinalAssessments() {
      const { caseConf } = this.emitter;
      return caseConf.spinalAssessments || [];
    },
  },
  mounted() {
    const data = this.getData(this.ikey);
    this.state.vertebrae = get(data, 'ids') || [];
    this.update();
  },
  methods: {
    setVertebrae(vertebrae) {
      this.state.vertebrae = vertebrae;
      this.update();
    },
    update() {
      this.putData(this.ikey, {
        type: 'SPINAL_ASSESSMENT',
        ids: this.state.vertebrae,
        operator: 'EQUAL',
        value: true,
      });
      this.emitter.trigger('process', this.control);
    },
  },
}
</script>

<style scoped>

</style>